import hamburger from './IconHamburger'
import cross from './IconCross'
import instagram from './IconInstagram'
import linkedin from './IconLinkedin'
import magnifier from './IconMagnifier'
import arrowRight from './IconArrowRight'

export default () => ({
  hamburger,
  cross,
  instagram,
  linkedin,
  magnifier,
  arrowRight,
})
